(function (Drupal, $, once) {
  Drupal.behaviors.featureBlocks = {
    attach: function (context) {
      $(function () {
          $(once("feature-blocks", ".paragraph-feature-blocks__content"))
          .each(function () {
            var splide = new Splide(
              $(this).find(".paragraph-feature-blocks.splide")[0],
              {
                type: "loop",
                speed: 1000,
                arrowPath:
                  "M8.33,20l20-20l3.33,3.33L15,20l16.67,16.67L28.33,40L8.33,20",
                mediaQuery: "min",
                breakpoints: {
                  1024: {
                    destroy: true,
                  },
                },
              }
            );

            splide.mount();

            $(
              ".paragraph-feature-blocks__items .paragraph-feature-blocks__item-link a"
            ).attr("tabindex", 0);
          });
      });
    },
  };
}(Drupal, jQuery, once));
